<template>
	<div class="header_menu_list">
	   <nav class="nav">
			
	      <ul class="ul_box">
				
	         <li class="li_dropdown" v-for="(item, index) in product_arr" :key="index" @mouseover="li_dropdown_mouseover(item)">
	            <div class="dropdown_title" @click="$go_official_website_page(item.series_url)">{{ item.series }}</div>
	               <div class="dropdown-content-box">
	                  <div class="dropdown-content" :class="item.series_id == 'HEADPHONES' ? 'HEADPHONES' : ''">
	                     
								<div class="leftRight-section-box">
									
									<div class="leftRight-section" :class="item.series_id == 'HEADPHONES' ? '' : 'marginLeft15'" v-if="item.classification && item.classification.length > 0">
								      <div class="showItems" :class="fication.id == ficationActive ? 'divActive' : ''" @click="$go_official_website_page(fication.url)" @mouseover="showItems(fication)" v-for="(fication, index_f) in item.classification" :key="index_f">
											<span class="showItemsTypeName">{{ fication.name }}</span>
										</div>
										
								      <!-- <a class="showItems" id="EARBUDS-showItems" href="" @onmouseover="showItems('EARBUDS')"><span class="showItemsTypeName"></span></a>
								      <a class="showItems" id="OPEN-EAR-showItems" href="" @onmouseover="showItems('OPEN-EAR')"><span class="showItemsTypeName"></span></a>
								      <a class="showItems" id="OVER-EAR-showItems" href="" @onmouseover="showItems('OVER-EAR')"><span class="showItemsTypeName"></span></a>
								      <a class="showItems" id="ON-EAR-showItems" href="#" @onmouseover="showItems('ON-EAR')"><span class="showItemsTypeName">ON-EAR</span></a> -->
								   </div>
									<!-- item.product_list -->
									<div class="dropdown-column" :class="item.series_id == 'HEADPHONES' ? 'marginLeft20' : (item.classification.length > 0 ? 'marginLeft30' : 'marginLeft15')">
									   <div class="a_item_box" v-for="(product, index_pro) in get_product_list" :key="index_pro" @click="$go_official_website_page(product.buy_now_url)">
									      <div class="product_img">
									         <img :src="product.img" :alt="product.name + ' main image'"/>
									      </div>
									      <div class="product_header_tag">
									         {{ product.tag }}
									      </div>
									      <div class="nav_product_name">
									         {{ product.name }}
									      </div>
									   </div>
									</div>
	                     </div>
	
	                     <div class="dropdown-footer" v-if="item.filter_arr && item.filter_arr.filter_list.length > 0">
	                        <div class="dropdown-footer-left">
	                           <div href="#" class="filter_name" @click="$go_official_website_page(filter.url)" v-for="(filter, index_filter) in item.filter_arr.filter_list" :key="index_filter">{{ filter.name }}</div>
	                        </div>
	                        <div class="dropdown-footer-right">
	                           <div href="#" class="ShopAll filter_name" @click="$go_official_website_page(item.filter_arr.all_list.url)">{{item.filter_arr.all_list.name}} <span class="el-icon-arrow-right"></span> </div>
	                        </div>
	                     </div>
	                  </div>
	               </div>
	            </li>
					
	            <!-- <li class="li_dropdown">
	               <div class="dropdown_title" @click="$go_official_website_page('/pages/coupon')">
	                  <div class="tozo_hot_box">
	                     {{ $t('nav_box.title.TOZO_COUPON') }}
	                     <div class="tozo_hot_img">
	            				<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
	                     </div>
	                  </div>
	               </div>
	            </li> -->
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/halloween-sale')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.HALLOWEEN_SALE') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/black-friday-cyber-monday-sale')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.BLACK_FRIDAY') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/mid-year-sale')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.MID_YEAR_SALE') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					<li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/2026-summer-activities')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.SUMMER_DEALS') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li>
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/soccer-match-2026')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.GAME_DEALS') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/collections/hot-sales')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.HOT_SALE') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/new-year-sale')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.NEW_YEAR_SALE') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/christmas-sale')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.CHRISTMAS_SALE') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/back-to-school')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.BACK_TO_SCHOOL') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/summer-sale')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.SUMMER_SALE') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/prime-day-deals')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.PRIME_DAY') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/independence-day-sale')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.INDEPENDENCE_DAY') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/fathers-day-sale')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.FATHERS_DAY') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					
	            <!-- <li class="li_dropdown">
	               <div class="dropdown_title" @click="$go_official_website_page('/pages/sound-deals')">
	                  <div class="tozo_hot_box">
	                     {{ $t('nav_box.title.SOUND_DEALS') }}
	                     <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp"/>
	                      </div>
	                  </div>
	               </div>
	            </li> -->
					
					<!-- <img src="https://cdn.shopify.com/s/files/1/0737/0578/3585/files/TOZO_hot.gif?v=1732066200" alt="TOZO hot Image"/> -->
					<!-- <li class="li_dropdown">
					   <div class="dropdown_title" @click="$go_official_website_page('/pages/mothers-day-sale')">
					      <div class="tozo_hot_box">
					         {{ $t('nav_box.title.MOTHERS_DAY_SALE') }}
					         <div class="tozo_hot_img">
									<img src="../../assets/TOZO_hot.webp" alt="TOZO hot icon image"/>
					         </div>
					      </div>
					   </div>
					</li> -->
					
					
	            
	            <li class="li_dropdown">
	               <a class="dropdown_title" href="/pages/support">{{ $t('nav_box.title.SUPPORT') }}</a>
	               <div class="dropdown-content-box">
	                  <div class="dropdown-content support-dropdown marginBottom">
	
	                        <div class="support-section-box marginLeft">
	                           <div class="support-section support-section-text">
	                              <div class="section-title">{{ support.title }}</div>
											<div class="section-text" v-for="(item, index) in support.text_list" :key="index" @click="$go_official_website_page(item.url)">{{ item.name }}</div>
	                           </div>
	                        </div>
	
	                        <div class="support-section-box">
	                           <div class="support-section support-section-iconBox">
	                              <div class="a_item_box" v-for="(item, index) in support.icon_list" :key="index" @click="$go_official_website_page(item.url)">
												<div class="icon_img">
													<div class="icon" v-html="$get_icon_name(item.icon_name)"></div>
												</div>
	                                 <div class="icon_name">
													{{ item.name }}
												</div>
	                              </div>
	                            </div>
	                        </div>
	
	                        <div class="support-section-box support-image-box">
	                           <div class="support-image">
	                              <img src="https://cdn.shopify.com/s/files/1/0737/0578/3585/files/SupportImg_new.png?v=1730701842" alt="TOZO Support Image"/>
	                           </div>
	                        </div>
	
	                  </div>
	               </div>
	            </li>
	            
	            <li class="li_dropdown">
	               <a class="dropdown_title" href="#">{{ $t('nav_box.title.EXPLORE') }}</a>
	               <div class="dropdown-content-box">
	                  <div class="dropdown-content explore-dropdown marginBottom">
	                     <div class="explore-section-box" v-for="(item, index) in explore_list" :key="index">
	                        <div class="explore-section">
	                           <div class="section-title">{{ item.title }}</div>
	                           <div class="section-text" v-for="(item_t, index_t) in item.text_list" :key="index_t" @click="go_page_url(item_t.url)">{{ item_t.name }}</div>
	                        </div>
	                     </div>
	                  </div>
	               </div>
	            </li>
	            
	        </ul>
	    </nav>
	</div>
</template>

<script>
let that = ""
export default {
	// name: 'MenuPc',

	// props: {
	// 	Post_List: {
	// 		type: Array,
	// 		default: []
	// 	},
	// },
	
	
	data() {
		return {
			ficationActive: "EARBUDS",
			get_product_list:[],
			product_arr:[
				{
					series: this.$t('nav_box.title.NEW_RELEASES'),
					series_id: "NEW_RELEASES",
					series_url: "/collections/new-releases",
					product_list:[
						// {
						// 	name: "TOZO Golden X1",
						// 	buy_now_url: "",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_X1_galaxy_black.png?v=1722477829",
						// 	// img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_X1_new.webp?v=1720092939"
						// 	tag: "",
						// 	type: []
						// },
						// {
						// 	name: "TOZO VIZO V1",
						// 	buy_now_url: "/products/tozo-vizo-v1",
						// 	img: "https://cdn.shopify.com/s/files/1/0766/6453/7387/files/TOZO_VIZO_V1_nav.png?v=1765879434",
						// 	tag: "",
						// 	type: []
						// },
						// {
						// 	name: "TOZO NC20",
						// 	buy_now_url: "/products/nc20",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_nc20_new.png?v=1762398299",
						// 	tag: "",
						// 	type: []
						// },
					
						{
							name: "TOZO NC9 Pro",
							buy_now_url: "/products/tozo-nc9-pro-active-noise-cancelling-wireless-earbuds-ldac-hi-res-audio",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC9_Pro.png?v=1789463963",
							tag: "",
							type: []
						},
						{
							name: "TOZO VIZO Z1 Pro",
							buy_now_url: "/products/tozo-vizo-z1-pro",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/TOZO_VIZO_Z1_Pro_nav.png?v=1775544615",
							tag: "",
							type: []
						},
						{
							name: "TOZO Open X2 Pro",
							buy_now_url: "/products/tozo-open-x2-pro",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_Open_X2_Pro.png?v=1784613404",
							tag: "",
							type: []
						},
						{
							name: "TOZO NC20 Pro",
							buy_now_url: "/products/nc20-pro",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_nc20pro_new.png?v=1762916272",
							tag: "",
							type: []
						},
						{
							name: "TOZO HT3",
							buy_now_url: "/products/ht3",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_ht3_new.png?v=1758792493",
							tag: "",
							type: []
						},
						{
							name: "TOZO OpenWear",
							buy_now_url: "/products/openwear",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_openwear_new.png?v=1760605303",
							tag: "",
							type: []
						},
						// new nc9
						// {
						// 	name: "TOZO NC9",
						// 	buy_now_url: "/products/2024-hybrid-active-noise-cancelling-wireless-earbuds",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC9_new.png?v=1739168680",
						// 	tag: "",
						// 	type: []
						// },
						// {
						// 	name: "TOZO VIZO Z1",
						// 	buy_now_url: "/products/tozo-vizo-z1",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/TOZO_VIZO_Z1_nav.png?v=1775544615",
						// 	tag: "",
						// 	type: []
						// },
						// {
						// 	name: "TOZO S8",
						// 	buy_now_url: "/products/s8-smartwatch",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_s8_new.png?v=1755086820",
						// 	tag: "",
						// 	type: []
						// },
						// {
						// 	name: "TOZO OpenOrb",
						// 	buy_now_url: "/products/openorb",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_openorb_new.png?v=1755086820",
						// 	tag: "",
						// 	type: []
						// },
						// {
						// 	name: "TOZO Open EarRing",
						// 	buy_now_url: "/products/openearring-headphone",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/tozo-open-earring.png?v=1728989140",
						// 	tag: "",
						// 	type: []
						// },
						// {
						// 	name: "TOZO Open Buds",
						// 	buy_now_url: "/products/open-buds",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_Openbuds.webp?v=1720092872",
						// 	tag: "",
						// 	type: []
						// },
						// {
						// 	name: "TOZO NC9",
						// 	buy_now_url: "/products/nc9",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_nc9.webp?v=1720092872",
						// 	tag: "",
						// 	type: []
						// },
						// {
						// 	name: "TOZO HT2",
						// 	buy_now_url: "/products/ht2",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_HT2.webp?v=1720092872",
						// 	tag: "",
						// 	type: []
						// },
					],
					classification: [],
					filter_list:[]
				},
				{
					series: this.$t('nav_box.title.HEADPHONES'),
					series_id: "HEADPHONES",
					series_url: "/collections/headphones",
					product_list:[
						{
							name: "TOZO NC20 Pro",
							buy_now_url: "/products/nc20-pro",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_nc20pro_new.png?v=1762916272",
							tag: "",
							type: ["EARBUDS"]
						},
						
						{
							name: "TOZO NC20",
							buy_now_url: "/products/nc20",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_nc20_new.png?v=1762398299",
							tag: "",
							type: ["EARBUDS"]
						},
						{
							name: "TOZO Golden X1",
							buy_now_url: "/products/golden-x1",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_X1_galaxy_black.png?v=1722477829",
							tag: "",
							type: ["EARBUDS"]
						},
						// new nc9
						{
							name: "TOZO NC9",
							buy_now_url: "/products/2024-hybrid-active-noise-cancelling-wireless-earbuds",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC9_new.png?v=1739168680",
							tag: "",
							type: ["EARBUDS"]
						},
						// {
						// 	name: "TOZO NC9",
						// 	buy_now_url: "/products/nc9",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_nc9.webp?v=1720092872",
						// 	tag: "",
						// 	type: ["EARBUDS"]
						// },
						{
							name: "TOZO NC3",
							buy_now_url: "/products/nc3-headphone",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC3.png?v=1739168680",
							tag: "",
							type: ["EARBUDS"]
						},
						// {
						// 	name: "TOZO NC2",
						// 	buy_now_url: "/products/nc2",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC2.png?v=1722477828",
						// 	tag: "",
						// 	type: ["EARBUDS"]
						// },
						{
							name: "TOZO A1",
							buy_now_url: "/products/a1",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_A1.png?v=1740017051",
							tag: "",
							type: ["EARBUDS"]
						},
						// {
						// 	name: "TOZO E1",
						// 	buy_now_url: "/products/e1-earbud",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_E1.png?v=1740017052",
						// 	tag: "",
						// 	type: ["EARBUDS"]
						// },
						
						{
							name: "TOZO Open X2 Pro",
							buy_now_url: "/products/tozo-open-x2-pro",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_Open_X2_Pro.png?v=1784613404",
							tag: "",
							type: ["OPEN-EAR"]
						},
						{
							name: "TOZO Open EarRing",
							buy_now_url: "/products/openearring-headphone",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/tozo-open-earring.png?v=1728989140",
							tag: "",
							type: ["OPEN-EAR"]
						},
						{
							name: "TOZO Open Buds",
							buy_now_url: "/products/open-buds",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_Openbuds.webp?v=1720092872",
							tag: "",
							type: ["OPEN-EAR"]
						},
						{
							name: "TOZO OpenWear",
							buy_now_url: "/products/openwear",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_openwear_new.png?v=1760605303",
							tag: "",
							type: ["OPEN-EAR"]
						},
						{
							name: "TOZO OpenEgo",
							buy_now_url: "/products/openego",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_OpenEgo.webp?v=1720092872",
							tag: "",
							type: ["OPEN-EAR"]
						},
						{
							name: "TOZO OpenReal",
							buy_now_url: "/products/openreal",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_OpenReal.webp?v=1720092872",
							tag: "",
							type: ["OPEN-EAR"]
						},
						// {
						// 	name: "TOZO OpenOrb",
						// 	buy_now_url: "/products/openorb",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_openorb_new.png?v=1755086820",
						// 	tag: "",
						// 	type: ["OPEN-EAR"]
						// },
						
						{
							name: "TOZO HT3",
							buy_now_url: "/products/ht3",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_ht3_new.png?v=1758792493",
							tag: "",
							type: ["OVER-EAR"]
						},
						{
							name: "TOZO HT2",
							buy_now_url: "/products/ht2",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_HT2.webp?v=1720092872",
							tag: "",
							type: ["OVER-EAR"]
						},
						{
							name: "TOZO HA1",
							buy_now_url: "/products/ha1-headphone",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_HA1.png?v=1727417350",
							tag: "",
							type: ["OVER-EAR"]
						},
						
						// {
						// 	name: "TOZO T20",
						// 	buy_now_url: "/products/t20",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_T20.png?v=1721205332",
						// 	tag: "",
						// 	type: ["EARBUDS"]
						// },
					],
					classification: [
						{
							id: "EARBUDS", 
							name: this.$t('nav_box.HEADPHONES.EARBUDS'),
							url: "/collections/earbuds"
						},
						{
							id: "OPEN-EAR",
							name: this.$t('nav_box.HEADPHONES.OPEN_EAR'),
							url: "/collections/open-ear-headphones"
						},
						{
							id: "OVER-EAR",
							name: this.$t('nav_box.HEADPHONES.OVER_EAR'),
							url: "/collections/headphones?gf_85670=Over-Ear"
						}
					],
					filter_arr: {
						all_list:{
							name: this.$t('nav_box.HEADPHONES.Shop_All_Headphones'),
							url: "/collections/headphones"
						},
						filter_list:[
							// {
							// 	name: this.$t('nav_box.HEADPHONES.Active_Noise_Cancelling'),
							// 	url: "/collections/headphones?gf_82588=Active+Noise+Cancelling",
							// },
							// {
							// 	name: this.$t('nav_box.HEADPHONES.Wireless_Charging'),
							// 	url: "/collections/headphones?gf_82588=Wireless+Charging",
							// },
							{
								name: this.$t('nav_box.HEADPHONES.Active_Noise_Cancelling'),
								url: "/collections/noise-canceling-earbuds",
							},
							{
								name: this.$t('nav_box.HEADPHONES.Fitness'),
								url: "/collections/fitness",
							},
							{
								name: this.$t('nav_box.HEADPHONES.Hi_Res_Audio'),
								url: "/collections/hi-res-audio-headphones",
							},
							{
								name: this.$t('nav_box.HEADPHONES.Premium_Call_Quality'),
								url: "/collections/premium-headphones",
							},
							{
								name: this.$t('nav_box.HEADPHONES.Gaming'),
								url: "/collections/gaming-headphones",
							},
							{
								name: this.$t('nav_box.HEADPHONES.Waterproof_Earbuds'),
								url: "/collections/waterproof-earbuds",
							},
							{
								name: this.$t('nav_box.HEADPHONES.Translate_Earbuds'),
								url: "/collections/translate-earbuds",
							},
						]
					}
				},
				{
					series: this.$t('nav_box.title.WATCHES'),
					series_id: "WATCHES",
					series_url: "/collections/watches",
					product_list:[
						{
							name: "TOZO S8",
							buy_now_url: "/products/s8-smartwatch",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_s8_new.png?v=1755086820",
							tag: "",
							type: []
						},
						{
							name: "TOZO S7",
							buy_now_url: "/products/s7-smartwatch",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_S7.png?v=1739168680",
							tag: "",
							type: []
						},
						{
							name: "TOZO S6",
							buy_now_url: "/products/s6-smartwatch",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_S6.png?v=1728269260",
							tag: "",
							type: []
						},
						{
							name: "TOZO S5",
							buy_now_url: "/products/s5",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_S5.webp?v=1720092872",
							tag: "",
							type: []
						},
						{
							name: "TOZO S4",
							buy_now_url: "/products/s4",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_S4.webp?v=1720092872",
							tag: "",
							type: []
						},
						// {
						// 	name: "TOZO S3",
						// 	buy_now_url: "/products/s3",
						// 	img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_S3.webp?v=1720092872",
						// 	tag: "",
						// 	type: []
						// }
					],
					classification: [],
					filter_list:[]
				},
				{
					series: this.$t('nav_box.title.SPEAKERS'),
					series_id: "SPEAKERS",
					series_url: "/collections/speaker",
					product_list:[
						{
							name: "TOZO PA2",
							buy_now_url: "/products/pa2",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_PA2.webp?v=1720092872",
							tag: "",
							type: []
						},
						{
							name: "TOZO PA1",
							buy_now_url: "/products/pa1",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_PA1.webp?v=1720092872",
							tag: "",
							type: []
						},
						{
							name: "TOZO PE1",
							buy_now_url: "/products/pe1-speaker",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_PE1.png?v=1730702681",
							tag: "",
							type: []
						},
						{
							name: "TOZO PM1",
							buy_now_url: "/products/pm1",
							img: "https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_pm1_new.png?v=1755086820",
							tag: "",
							type: []
						},
					],
					classification: [],
					filter_list:[]
				}
			],
			support:{
				title: this.$t('nav_box.SUPPORT.SERVICES'),
				text_list: [
					{
						name: this.$t('nav_box.SUPPORT.Support_Center'),
						url: "/pages/support"
					},
					{
						name: this.$t('nav_box.SUPPORT.Process_Warranty'),
						url: "/pages/process-a-warranty"
					},
					{
						name: this.$t('nav_box.SUPPORT.Order_Tracker'),
						url: "/apps/17TRACK"
					},
					{
						name: this.$t('nav_box.SUPPORT.Privacy_Center'),
						url: "/pages/privacy-policy"
					},
					{
						name: this.$t('nav_box.SUPPORT.Contact_Us'),
						url: "/pages/contact-us"
					}
				],
				icon_list: [
					{
						name: this.$t('nav_box.SUPPORT.FAQs'),
						icon_name: "header_faq",
						url: "/pages/faq"
					},
					{
						name: this.$t('nav_box.SUPPORT.Support_Videos'),
						icon_name: "header_SupportVideos",
						url: "/pages/videotutorial"
					},
					// {
					// 	name: "CYBER_MONDAY",
					// 	icon_name: "header_Troubleshooting",
					// 	url: "/pages/black-friday-cyber-monday-sale"
					// },
					{
						name: this.$t('nav_box.SUPPORT.Manuals'),
						icon_name: "header_quickGuide",
						url: "/pages/manuals"
					},
					{
						name: this.$t('nav_box.SUPPORT.Warranty_Info'),
						icon_name: "header_warranty-policy",
						url: "/pages/warranty-policy"
					},
					// {
					// 	name: "APPs Download",
					// 	icon_name: "header_APPsUpgrade",
					// 	url: "/pages/airyear"
					// }
				]
			},
			explore_list:[
				{
					title: this.$t('nav_box.EXPLORE.ACTIVITIES'),
					text_list: [
						// {
						// 	name: this.$t('nav_box.title.Campaign'),
						// 	url: "#"
						// },
						{
							name: this.$t('nav_box.EXPLORE.CES_2026'),
							url: "/pages/ces-2026"
						},
						{
							name: this.$t('nav_box.EXPLORE.CES_2025'),
							url: "/pages/ces-2025"
						},
						{
							name: this.$t('nav_box.EXPLORE.CES_2024'),
							url: "/pages/ces-2024"
						},
						// {
						// 	name: this.$t('nav_box.EXPLORE.NC20_Pro_Coming'),
						// 	url: "/pages/nc20-pro-coming"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.NC20_Available'),
						// 	url: "/pages/nc20-launch"
						// },
					]
				},
				
				{
					title: this.$t('nav_box.EXPLORE.PROMOTION'),
					text_list: [
						{
							name: this.$t('nav_box.EXPLORE.HT3_Coming_Soon'),
							url: "/pages/ht3-coming-soon"
						},
						{
							name: this.$t('nav_box.EXPLORE.CHRISTMAS_SALE'),
							url: "/pages/christmas-sale"
						},
						{
							name: this.$t('nav_box.EXPLORE.TOZO_Coupon'),
							url: "/pages/coupon"
						},
						// {
						// 	name: this.$t('nav_box.EXPLORE.Halloween_Sale'),
						// 	url: "/pages/halloween-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.HOT_SALE'),
						// 	url: "/collections/hot-sales"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.Back_To_School'),
						// 	url: "/pages/back-to-school"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.SUMMER_SALE'),
						// 	url: "/pages/summer-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.PRIME_DAY'),
						// 	url: "/pages/prime-day-deals"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.INDEPENDENCE_DAY'),
						// 	url: "/pages/independence-day-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.FATHERS_DAY'),
						// 	url: "/pages/mothers-day-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.EARTH_DAY_SALE'),
						// 	url: "/pages/earth-day-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.VALENTINE_S_DAY'),
						// 	url: "/pages/valentines-day-sale"
						// },
						// {
						// 	name: this.$t('nav_box.EXPLORE.SOUND_DEALS'),
						// 	url: "/pages/sound-deals"
						// },
						{
							name: this.$t('nav_box.EXPLORE.TOZOAiryEar'),
							url: "/pages/airyear"
						}
					]
				},
				{
					title: this.$t('nav_box.EXPLORE.CLUB'),
					text_list: [
						// {
						// 	name: "Community",
						// 	url: "#"
						// },
						{
							name: this.$t('nav_box.EXPLORE.Blog'),
							url: "/blogs/news"
						},
						{
							name: this.$t('nav_box.EXPLORE.Forum'),
							url: "Forum"
						},
						// {
						// 	name: "Press & video",
						// 	url: "#"
						// },
					]
				},
				{
					title: this.$t('nav_box.EXPLORE.BRAND'),
					text_list: [
						{
							name: this.$t('nav_box.EXPLORE.Our_Story'),
							url: "/pages/Our-Story"
						},
						{
							name: this.$t('nav_box.EXPLORE.Technology'),
							url: "/pages/technology"
						},
						// {
						// 	name: "Newsroom",
						// 	url: "#"
						// }
					]
				},
				{
					title: this.$t('nav_box.EXPLORE.TOZO_Distrbutor_Portal'),
					text_list: [
						{
							name: this.$t('nav_box.EXPLORE.Become_a_Distribution_Partner'),
							url: "https://b2b.tozostore.com/"
						},
					]
				}
			]
		}
	},
	
	// 监听
	watch: {
		// "Post_List": {
		// 	handler: function (newValue, oldValue) {
		// 		this.list = this.Post_List
		// 	},
		// 	deep: true
		// },
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
	  that = this
	},
  
	mounted() {
		// this.list = this.Post_List
		this.get_li_dropdown()
	},
  
	methods:{
		go_page_url(url){
			if(url == 'Forum'){
				this.$router.push({
					name: "home",
					params: {}
				})
			}else{
				if (url && url.includes('http')) {
				   // 新窗口打开外部URL
				   window.open(url, '_blank');
				} else {
				   // 使用路由跳转到内部页面
				   this.$go_official_website_page(url);
				}
			}
		},
		
		get_li_dropdown(){
			// get_screenWidth()
			// Add JavaScript functionality here
			const dropdowns = document.querySelectorAll('.li_dropdown');
		 
			dropdowns.forEach(dropdown => {
		     dropdown.addEventListener('mouseover', function() {
		         const dropdownContent = this.querySelector('.dropdown-content-box');
		         if (dropdownContent) {
		            dropdownContent.classList.add('show');
		         }
		 		  
		 		   that.showItems(that.ficationActive)
				});
		 		   
				dropdown.addEventListener('mouseout', function() {
		         if(this.querySelector('.dropdown-content-box')){
		            this.querySelector('.dropdown-content-box').classList.remove('show'); 
		         }
				});
			});
			window.addEventListener('resize', function() {
				// that.thatget_screenWidth()
			});
		},
	  
	  
	   get_parameter(showItemsElement){
	      const onmouseoverAttribute = showItemsElement.getAttribute('onmouseover');
	      const matches = onmouseoverAttribute.match(/showItems\('([^']*)'\)/);
	      if (matches) {
	         console.log(matches[1]); // 输出 'Drone_accessories'
	      }
	   },
	  
	   showItems(fication) {
			console.log(fication)
			this.ficationActive = fication.id ? fication.id : fication
	   },
	  
	   get_screenWidth(){
	      // 获取所有具有类名 '.dropdown-content-box' 的元素
	      const boxes = document.querySelectorAll('.dropdown-content-box');
	  
	      // 获取屏幕宽度
	      const screenWidth = window.innerWidth;
	      let offset = 0
	  
	      // 如果屏幕宽度大于1280像素，则计算左边界的值
	      if (screenWidth > 1280) {
	         offset = (screenWidth - 1280) / 2;
	      }else{
	         offset = 0
	      }
	   },
		
		li_dropdown_mouseover(boj){
			this.get_product_list = this.get_product_list_fun(boj)
		},
		
		get_product_list_fun(boj){
			let list = []
			let that = this
			if(boj.classification && boj.classification.length > 0){
				boj.product_list.forEach((item)=>{
					if(item.type.map(item => item.toLowerCase()).includes(that.ficationActive.toLowerCase())){
						list.push(item)
					}
				})
			}else{
				list = boj.product_list
			}
			return list
		},
		
		//查看 粉丝或关注人信息
		check_information(item){
			console.log(item)
		},
	
	}
}
</script>

<style lang="less" scoped>
   .div_header_box{
      background: #ffffff;
	   position: relative;
   }
   .header_menu_list {
      margin: 0;
      padding: 0px 40px;
      width: 100%;
	}
    @media only screen and (min-width: 1024px) {
        .header_menu_list {
            height: 80px;
        }
    }
    .header_menu_list *{
        font-family: Poppins;
        box-sizing: border-box;
	}

    .dropdown-content-box img{
        font-size: 12px;
    }
	
	.header_menu_list nav {
        /* position: relative; */
        width: 100%;
	}
	
	.header_menu_list ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
        display: flex;
        /* justify-content: space-between; */
	}

	
	.header_menu_list ul li a {
        display: block;
        /* text-align: center; */
        text-decoration: none;
	}
    
    .dropdown_title{
        font-size: 14px;
        color: #111111;
        margin: 0 10px;
        padding: 28.5px 0px;
        /* border-bottom: 2px solid #ffffff; */
    }
    .tozo_hot_box{
        display: flex;
        position: relative;
    }
    .tozo_hot_img{
        margin-left: 0px;
        margin-top: -10px;
    }
    .tozo_hot_img img{
        display: block;
        width: 100%;
        max-width: 23px;
        /* max-width: 14px; */
    }
	
	.header_menu_list ul li:hover .dropdown_title{
        /* color: #999999; */
        border-bottom: 2px solid #000000;
	}

    @keyframes blink {
        0% { opacity: 1; } /* 开始时完全显示 */
        50% { opacity: 0; } /* 50%时完全隐藏 */
        100% { opacity: 1; } /* 结束时再次完全显示 */
    }
	
    .dropdown-content-box{
        display: none;
        position: absolute;
        background-color: #ffffff;
        width: 100%;
        /* width: 100vw; */
        z-index: 99;
        left:0;
        padding: 30px 0px 10px 0px;
        box-sizing: border-box;
        border-top: .01rem solid #ececec;

        box-shadow: 0 2px 4px rgba(0,0,0,0.1); /* 全局阴影设置 */
        transition: opacity 0.8s ease-in-out;
        opacity: 0;
        /* box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2); 保留左右和底部的阴影 */
        /* -webkit-box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2); Safari 和 Chrome */
        /* -moz-box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2); Firefox */
        /* box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2); 标准语法 */
    }

    .dropdown-content-box.show {
        display: block;
        opacity: 1;
    }

	.dropdown-content {
        /* border: 1px blue solid; */
        max-width: 1280px;
        width: 100%;
        box-sizing: border-box;
        // padding-left: 162px;
        margin: auto;
        margin-top: 20px;
	}
	.support-dropdown{
        padding-left: 179px;
	}
    .explore-dropdown{
        padding: 0px 0px 0px 180px;
    }
    .dropdown-footer {
        // max-width: calc(100vw - 21.5%);
    }
	 @media only screen and (min-width: 1320px){
		.HEADPHONES.dropdown-content {
		   padding-left: 0px !important;
		}
	 }
    @media only screen and (min-width: 1320px) and (max-width: 1500px) {
			.dropdown-content {
				// padding-left: 145px;
				// padding: 0px 20px;
			}
			.HEADPHONES.dropdown-content {
				padding-left: 0px !important;
			}
			.header_menu_list {
            padding: 0px 20px;
			}
			.support-dropdown{
				padding-left: 160px;
			}
			.explore-dropdown{
            padding: 0px 0px 0px 160px;
			}
    }
    @media only screen and (min-width: 1280px) and (max-width: 1320px) {
        .dropdown-content {
            // padding-left: 166px;
				padding: 0px 20px;
        }
			.HEADPHONES.dropdown-content {
				padding-left: 20px !important;
			}
        .header_menu_list {
            padding: 0px 20px;
        }
			.support-dropdown{
				padding-left: 179px;
			}
        .explore-dropdown{
            padding: 0px 0px 0px 179px;
        }
    }
    @media only screen and (min-width: 1100px) and (max-width: 1280px) {
        .dropdown-footer {
            // max-width: calc(100vw - 200px);
        }
        .header_menu_list {
            padding: 0px 20px;
        }
        .dropdown-content {
            // padding-left: 148px;
				padding: 0px 20px;
        }
			.HEADPHONES.dropdown-content {
				padding-left: 20px !important;
			}
        .explore-dropdown{
            padding: 0px 0px 0px 165px;
        }
			.support-dropdown{
				padding-left: 166px;
			}
        .dropdown_title{
            margin: 0 5px;
        }
    }
    @media only screen and (min-width: 1024px) and (max-width: 1100px) {
        .dropdown-footer {
            // max-width: calc(100vw - 170px);
        }
        .header_menu_list {
            padding: 0px 5px;
        }
        .dropdown-content {
            // padding-left: 134px;
				padding: 0px 20px;
        }
		  .HEADPHONES.dropdown-content {
				padding-left: 20px !important;
		  }
        .explore-dropdown{
            padding: 0px 0px 0px 149px;
        }
			.support-dropdown{
				padding-left: 148px;
			}
        .dropdown_title{
            margin: 0 2px;
        }
    }
    @media only screen and (max-width: 1024px) {
        .dropdown-footer {
            // max-width: calc(100vw - 170px);
        }
        .header_menu_list {
            padding: 0px 0px;
        }
        .dropdown-content {
            // padding-left: 139px;
				padding: 0px 20px;
        }
        .explore-dropdown{
            padding: 0px 0px 0px 149px;
        }
			.support-dropdown{
				padding-left: 149px;
			}
        .dropdown_title{
            margin: 0 0px;
        }
    }
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
		.HEADPHONES.dropdown-content {
			padding-left: 15px !important;
		}
    }
    @media only screen and (max-width: 767px) {
		.HEADPHONES.dropdown-content {
			padding-left: 10px !important;
		}
    }
	
	.dropdown-content .dropdown-column {
        display: flex;
        width: 100%;
        /* padding: 0px 15px 0px 15px; */
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
	}
	
	.dropdown-content .dropdown-footer {
        width: 100%;
        margin-top: 5px;
        clear: both;
        display: flex;
        justify-content: space-between;
        padding: 15px 0px;
        font-size: 13px;
        background-color: #ffffff;
	}
    
    .footer-items-box{
        width: 100%;
    }

    .footer-items{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #7A7A7A;
    }

    .dropdown-footer .filter_name{
        padding: 10px;
        border-radius: 8px;
		  display: flex;
		  flex-wrap: nowrap;
		  &:nth-child(1){
			  margin-left: -10px;
		  }
    }
    
    .dropdown-footer .filter_name:hover{
	    text-decoration: underline;
    }
	
	.dropdown-content .dropdown-footer-left{
	   display: flex;
      color: #7A7A7A;
		display: flex;
		flex-wrap: wrap;
	}
	.dropdown-content .dropdown-footer-right {
	    display: flex;
	}
    .dropdown-content .dropdown-footer-right .ShopAll{
        display: flex;
	    align-items: center;
        font-size: 14px;
        color: #505050;
	}
    .dropdown-content .dropdown-footer-right .icon-left{
        width: 10px;
        display: block;
        font-size: 16px;
        margin-left: 5px;
        margin-top: 0px;
        font-family: Poppins;
    }
	
	.dropdown:hover .dropdown-content {
	    display: block;
        width: 100%;
	}
	
	.dropdown-content a {
        color: #333;
        display: block;
        text-decoration: none;
	}
	
	.dropdown-content .a_item_box:hover {
	    /* background-color: #f1f1f1; */
	}
    .li_dropdown{
        cursor: pointer;
    }
    @media only screen and (min-width: 1362px) {
        .li_dropdown{
            padding: 0px 0.55rem;
        }
    }
    @media only screen and (max-width: 1362px) and (min-width: 1311px) {
        .li_dropdown{
            padding: 0px 0.6rem;
        }
    }
    @media only screen and (max-width: 1311px) and (min-width: 1280px) {
        .li_dropdown{
            padding: 0px 0.5rem;
        }
    }
    @media only screen and (max-width: 1311px) and (min-width: 1284px) {
        .li_dropdown{
            padding: 0px 1.05%;
        }
    }
    @media only screen and (max-width: 1284px) and (min-width: 1230px) {
        .li_dropdown{
            padding: 0px 0.95%;
        }
    }
    @media only screen and (max-width: 1230px) and (min-width: 1180px) {
        .li_dropdown{
            padding: 0px 0.73%;
        }
    }
    @media only screen and (max-width: 1180px) and (min-width: 1140px) {
        .li_dropdown{
            padding: 0px 0.35%;
        }
    }
    @media only screen and (max-width: 1140px) and (min-width: 1110px) {
        .li_dropdown{
            padding: 0px 0.1%;
        }
    }
    @media only screen and (max-width: 1110px) and (min-width: 1090px) {
        .li_dropdown{
            padding: 0px 0%;
        }
    }
    @media only screen and (max-width: 1090px) and (min-width: 1080px) {
        .li_dropdown{
            padding: 0px 0.9%;
        }
    }
    @media only screen and (max-width: 1080px) and (min-width: 1050px) {
        .li_dropdown{
            padding: 0px 0.65%;
        }
    }
    @media only screen and (max-width: 1050px) and (min-width: 1035px) {
        .li_dropdown{
            padding: 0px 0.5%;
        }
    }
    @media only screen and (max-width: 1035px) and (min-width: 1024px) {
        .li_dropdown{
            padding: 0px 0.4%;
        }
    }
    
    .li_dropdown .a_item_box{
	    background-color: #F6F7FA;
        margin-right: 15px;
        border-radius: 8px;
        /* max-width: 210px; */
        max-width: 180px;
        min-width: 180px;
        padding: 15px 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 15px;
    }
    .li_dropdown .a_item_box:last-child{
        /* margin-right: 0px; */
    }
    .li_dropdown .HEADPHONES .a_item_box:last-child{
      margin-right: 0px;
    }
    .li_dropdown .a_item_box:hover{
	    /* background-color: #f1f1f1; */
    }

    .product_img img{
		 width: 100%;
        border-radius: 8px;
    }
	
	.product_header_tag {
	   margin-top: 5px;
      min-height: 20px;
      align-items: center;
      display: flex;
      justify-content: center;
      color: #E80909;
      font-size: 10px;
	}
    .nav_product_name{
	    margin-top: 5px;
        color: #3C3C3C;
	    font-size: 15px;
    }
	
	.section-title {
	    font-weight: bold;
        font-size: 14px;
	    padding: 0px 0px;
        color: #111111;
        margin-bottom: 24px;
	}

    .section-text{
        font-size: 14px;
    }

    .support-dropdown{
        display: flex;
    }

    .support-section-box{
        flex:1;
    }
    
    .support-section-box:nth-child(1){
        max-width: 195px;
    }

    .support-section-text{
        padding: 0px 50px 0px 0px;
        box-sizing: border-box;
        border-right: 1px #C3C3C3 solid;
    }

    .support-section-text .section-text{
	    color: #111111;
	    padding: 0px 0px;
        text-align: left;
        font-size: 14px;
        margin-bottom: 18px;
    }
    .support-section-text .section-text:last-child{
        margin-bottom: 0px;
    }
    .support-section-text .section-text:hover {
	    text-decoration: underline;
	}

    .support-section-iconBox{
	    margin-left: 35px;
        display: flex;
        flex-wrap: wrap; /* 允许项目在需要时换行 */
    }

    .support-section-iconBox .a_item_box{
        margin-bottom: 10px;
        min-width: 200px;
        /* min-width: 150px; */
        background-color: #ffffff;
    }

    .support-section-iconBox .icon_name{
        color: #3C3C3C;
        text-align: center;
        font-size: 15px;
        margin-top: 2px;
    }
    .header_dropDown_icon{
        height: auto;
        width: auto;
    }

    .support-dropdown{
        display: flex;
    }
	
    .support-section .icon_img{
        max-width: 30px;
    }

    .support-image-box{
        width: 100%;
        max-width: 385px;
        text-align: center;
    }

    @media only screen and (max-width: 1280px) {
        .support-image-box{
            display: none;
        }
        .support-section-iconBox {
            max-width: 520px;
        }
    }

	.support-image {
        width: 100%;
	}
    .support-image img{
        width: 100%;
	    height: 100%;
	    max-height: 195px;
        border-radius: 5px;
	}

    .explore-dropdown{
        display: flex;
        justify-content: flex-start;
    }

    .explore-section-box{
        border-right: 1px #C3C3C3 solid;
        display: flex;
        justify-content: flex-start;
        padding: 0px 55px;
    }

    .explore-section-box:nth-child(1){
        padding-left: 0px;
    }

    .explore-section-box:last-child{
        border-right: 0px;
    }

    .explore-section{
        /* flex:1; */
    }
	
	.explore-section .section-text {
	   display: block;
	   color: #333;
	   padding: 0px 0px;
      text-align: left;
      font-size: 14px;
      margin-bottom: 18px;
	}
    .explore-section .section-text:last-child{
        margin-bottom: 0px;
    }
	
	.explore-section .section-text:hover {
	    text-decoration: underline;
	}

    /* 这里可以添加你的样式 */
    .leftRight-section-box {
        display: flex;
    }

    .leftRight-section {
        box-sizing: border-box;
        text-align: left;
        min-width: 150px;
        display: block;
        max-height: 135px;
        border-right: .01rem solid #ececec;
    }
	 .HEADPHONES .leftRight-section {
        min-width: 105px;
    }

    .leftRight-section .showItems{
        text-align: left;
        color: #111111;
        font-size: 14px;
        font-weight: 600;
        /* max-width: 75px; */
        border-bottom: 2px #ffffff solid;
        margin-bottom: 36px;
    }
    .leftRight-section .showItems:last-child{
        margin-bottom: 0px;
    }

    .leftRightItems {
        flex: 2;
        margin-left: 40px; /* 调整左右间距 */
    }

    .showItems.divActive .showItemsTypeName {
        border-bottom: 2px #000000 solid;
    }

    .marginLeft15{
        // margin-left: 15px;
    }
    .marginLeft20{
        // margin-left: 20px;
    }
    .marginLeft30{
        // margin-left: 30px;
    }
    .marginBottom{
        margin-bottom: 30px;
    }
</style>

